import React from 'react'
import { BASE_API_URL } from '../../config/pathApi'

export const Ready = () => {
  return <div>Ready</div>
}

export const Alive = () => {
  return (
    <div>
      Alive
      <br /> window._env_.NODE_ENV = {window._env_.NODE_ENV}
      <br /> REACT_APP_ENV = {process.env.REACT_APP_ENV}
      <br /> BASE_API_URL = {BASE_API_URL}
      <br />
    </div>
  )
}
